import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SelectOption } from './model/option.interface';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectComponent,
      multi: true
    }
  ]
})
export class SelectComponent implements OnInit, ControlValueAccessor {

  @Input()
  labelText: string;

  @Input()
  options: SelectOption[];

  @Input()
  disabled: boolean;

  @Input()
  placeholder: string;

  @Input()
  required: boolean;

  @Input()
  submitted: boolean;

  @Input()
  labelWarningGenericText:boolean;

  model: string;
  onChange!: (value: any) =>  void;

  constructor(private readonly rf: ChangeDetectorRef) { 
    this.model = '';
    this.disabled = false;
    this.labelText = '';
    this.options = [];
    this.placeholder = '';
    this.required = false;
    this.submitted = false;
    this.labelWarningGenericText = false
  }

  writeValue(obj: any): void {
    this.model = obj;
    this.rf.detectChanges();
  }
  
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  
  registerOnTouched(fn: any): void {  }

  setDisabledState?(isDisabled: boolean): void {  }

  ngOnInit(): void {
    console.log(this.options);
  }
}
